import { MODULES, type ModuleType, type NeedKind } from "@station-keeping/sim";

/** Couleurs du rendu : les mêmes que les jetons de styles.css (les sprites pixel art en sont tirés). */
export const COLORS = {
  void: 0x05070f,
  deep: 0x0a1020,
  panel: 0x0f1830,
  panel2: 0x152246,
  line: 0x24345f,
  ink: 0xe8eeff,
  muted: 0xa3b0d4,
  dim: 0x8190b8,
  accent: 0x6fd3ff,
  good: 0x5ee0a4,
  warn: 0xffc65c,
  alert: 0xff9a5c,
  stop: 0xff7a8a,
  night: 0x8f9cff,
  weightless: 0x2b5a9e,
  gravity: 0x7a5aa8,
} as const;

const NEED_COLORS: Record<NeedKind, number> = {
  fuel: 0xff9f5a,
  repair: 0x8fb3ff,
  rest: 0xff9fc8,
  trade: 0x8ee07a,
};

/** Couleur d'accent d'un module : sa famille, ou le besoin qu'il sert. */
export function moduleColor(type: ModuleType): number {
  const def = MODULES[type];
  if (def.service && type !== "core") return NEED_COLORS[def.service];
  switch (def.category) {
    case "core":
      return 0xeaf2ff;
    case "docking":
      return 0x6fd3ff;
    case "energy":
      return 0xffd166;
    case "life":
      return 0x5ee0c0;
    case "living":
      return 0xb49cff;
    case "maintenance":
      return 0x3fd0c9;
    default:
      return COLORS.accent;
  }
}

export function needColor(kind: NeedKind): number {
  return NEED_COLORS[kind];
}

/** Couleur d'une panne selon son palier : ambre, orange, corail (jamais le rouge vif d'un incendie). */
export function stageColor(stage: 1 | 2 | 3): number {
  return stage === 1 ? COLORS.warn : stage === 2 ? COLORS.alert : COLORS.stop;
}

/** Couleur CSS d'un entier 0xRRGGBB, pour l'interface. */
export function cssColor(color: number): string {
  return `#${color.toString(16).padStart(6, "0")}`;
}
